import React from 'react';
import { Heading, HeadingProps } from 'components/Typography';
import * as S from './styles';

type TextProps = Omit<HeadingProps, 'level'>;

const PrimaryText: React.FC<TextProps> = (props) => (
  <Heading level={5} {...props} />
);

const SecondaryText: React.FC<TextProps> = (props) => (
  <Heading level={2} {...props} />
);

const DescriptionHeadline = Object.assign(S.Headline, {
  PrimaryText,
  SecondaryText,
});

export default DescriptionHeadline;
